import React, { useState } from "react";
import { FaCoins, FaUniversity, FaBitcoin, FaCog, FaBox } from "react-icons/fa";
import BaseModal from "./BaseModal";
import CashAccountForm from "./CashAccountForm";
import BankAccountForm from "./BankAccountForm";
import CryptoAccountForm from "./CryptoAccountForm";
import FixedAssetForm from "./FixedAssetForm";
import TradingAssetForm from "./TradingAssetForm";

const AssetRegistrationModal = ({ 
  isOpen, 
  onClose, 
  assetType, 
  currentAssetSubType,
  onRegister
}) => {
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  const getModalTitle = () => {
    let title = "Register ";
    if (assetType === "current") {
      title += `${currentAssetSubType.charAt(0).toUpperCase() + currentAssetSubType.slice(1)} `;
    }
    title += `${assetType.charAt(0).toUpperCase() + assetType.slice(1)} Asset`;
    return title;
  };

  const handleSubmit = async (formData) => {
    setIsLoading(true);
    try {
      let endpoint = "";

      if (assetType === "current") {
        if (currentAssetSubType === "cash") {
          endpoint = `${process.env.REACT_APP_BASE_URL}/api/assets/current-assets/cash`;
        } else if (currentAssetSubType === "bank") {
          endpoint = `${process.env.REACT_APP_BASE_URL}/api/assets/current-assets/bank`;
        } else if (currentAssetSubType === "crypto") {
          endpoint = `${process.env.REACT_APP_BASE_URL}/api/assets/current-assets/crypto`;
        }
      } else if (assetType === "fixed") {
        endpoint = `${process.env.REACT_APP_BASE_URL}/api/assets/fixed-assets`;
      } else if (assetType === "trading") {
        endpoint = `${process.env.REACT_APP_BASE_URL}/api/assets/trading-assets`;
      }

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success) {
        alert("Asset registered successfully!");
        onRegister();
        onClose();
      } else {
        alert(data.error || "Failed to register asset");
      }
    } catch (error) {
      console.error("Error registering asset:", error);
      alert("Failed to register asset");
    }
    setIsLoading(false);
  };

  const renderForm = () => {
    const commonProps = {
      onSubmit: handleSubmit,
      isLoading,
      isEdit: false
    };

    if (assetType === "current") {
      switch (currentAssetSubType) {
        case "cash":
          return <CashAccountForm {...commonProps} />;
        case "bank":
          return <BankAccountForm {...commonProps} />;
        case "crypto":
          return <CryptoAccountForm {...commonProps} />;
        default:
          return <div>Unknown current asset type</div>;
      }
    } else if (assetType === "fixed") {
      return <FixedAssetForm {...commonProps} />;
    } else if (assetType === "trading") {
      return <TradingAssetForm {...commonProps} />;
    }

    return <div>Unknown asset type</div>;
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={getModalTitle()}
      maxWidth="max-w-2xl"
    >
      {renderForm()}
    </BaseModal>
  );
};

export default AssetRegistrationModal;



